
import wx from 'weixin-js-sdk'
import Group from 'vux/src/components/group/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import imgup from '@/assets/upload_img.png'
import config from '@/config/index'
import Storage from '@/storage'
import store from '@/store'
import { getConfig, addFile } from '@/api/wx.js'
import { getLawaskDetail, answerLawyer } from '@/api/lawyer'
export default {
name: 'lawanswer',
components: {
Group,
XTextarea,
PopupPicker,
XButton,
Flexbox,
FlexboxItem
},
data () {
return {
searchVal: '',
baseUrl: config.baseUrl,
lawid: this.$route.params.id,
imgup: imgup,
list: [],
adcont: '',
upimagelist: [],
imgcount: 5,
fileList: { fileUrlArr: [], fileIdArr: [] },
imglist: { fileUrlArr: [], fileIdArr: [] },
options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[
index
]
let pageYScroll =
window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
}
}
},
created () {
this.getlist()
},
mounted () {


setTimeout(() => {
this.wxconfig()
}, 300)
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
getlist () {
getLawaskDetail({
id: this.$route.params.id
}).then(data => {
this.list = data.returnValue
this.list.description = this.list.description.replace(/\n|\r\n/g, '<br/>')
let _this = this
data.returnValue.askpicsList.forEach(res => {
_this.imglist.fileUrlArr.push(_this.baseUrl + res.FILEPATH)
})
})
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href,
sicode: config.sicode
}).then(re => {

let configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] 
})
})
},

chooseFile (imglist, filelist, imgcount) {

var _this = this
wx.chooseImage({
count: _this[imgcount], // 默认5
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: res => {
var localIds = res.localIds
_this.index = 0
if (localIds.length > 0) {
_this[imgcount] = _this[imgcount] - localIds.length
_this.uploadFile(imglist, filelist, localIds)
}
}
})
},

uploadFile (imglist, filelist, localIds) {
var _this = this
if (_this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
filelist.fileUrlArr.push(config.baseUrl + re.returnValue.filepath)
filelist.fileIdArr.push(re.returnValue.id)
})
_this.index++
_this.uploadFile(imglist, filelist, localIds)
}
})
},

preview (index, filelist) {
var _this = this
wx.previewImage({
current: filelist.fileUrlArr[index], // 当前显示图片的http链接
urls: filelist.fileUrlArr 
})
},

imgclose (imglist, index, filelist, imgcount) {
const _this = this 
this.$vux.confirm.show({
title: '提示',
content: '您确定要删除这张图片么？',

onCancel () {},
onConfirm () {
_this[imgcount] = _this[imgcount] + 1
imglist.splice(index, 1)
filelist.fileIdArr.splice(index, 1)
}
})
},
addAdvice () {
if (this.adcont === '') {
this.$vux.toast.text('请输入回复信息', 'middle')
return false
}
answerLawyer({
id: this.$route.params.id,
answer: this.adcont,
answerpics: this.fileList.fileIdArr.join(';')
}).then(data => {
this.$vux.toast.text('提交成功', 'middle')
this.$router.push({ name: 'mylawyerAsk' })
})
}
}
}
